import { Subscription } from 'rxjs';
import { AppConfig } from '../../app.config';
import { DashboardEventService } from '../../dashboard/dashboard-event.service';
import { Component, OnInit, Output, AfterViewInit, OnDestroy, Input } from '@angular/core';
import { UserProfileReporting } from '@liquitics/transaction';

@Component({
    selector: 'app-home-sidebar-reporting',
    templateUrl: './sidebar-reporting.component.html',
    styleUrls: ['./../home.sidebar.component.scss', './sidebar-reporting.component.scss']
})
export class SidebarReportingComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input()
    profileType: string;
    subscription: Subscription;
    viewMode: string;
    isReportDashboardDesigner: boolean;
    isReportDashboardViewer: boolean;
    isReportDashboardAdmin: boolean;

    constructor(
        private dashboardEventService: DashboardEventService,
        private appConfig: AppConfig) {
    }

    ngOnInit() {
        const reportingProfile: UserProfileReporting = this.appConfig.activeUserProfile as UserProfileReporting;
        this.isReportDashboardDesigner = reportingProfile.isReportDashboardDesigner();
        this.isReportDashboardViewer = reportingProfile.isReportDashboardViewer();
        this.isReportDashboardAdmin = reportingProfile.isReportDashboardAdmin();
        if (this.isReportDashboardDesigner || this.isReportDashboardAdmin) {
            this.viewMode = 'DESIGN';
            this.dashboardEventService.viewModeSelectionSubject.next(this.viewMode);
        } else if (this.isReportDashboardViewer || this.isReportDashboardAdmin) {
            this.viewMode = 'VIEW';
            this.dashboardEventService.viewModeSelectionSubject.next(this.viewMode);
        }
    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    ngAfterViewInit() {
    }

    initializeSideBar() {
    }

    onViewModeChange(event) {
        this.viewMode = event.value;
        this.dashboardEventService.viewModeSelectionSubject.next(event.value);
    }
}
